






























import { UserPromotionListEntry, UserPromotionMessage } from "@/types";
import Vue from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";

@Component({
  components: {},
})
export default class UserPromotionMessageHistoryDialog extends Vue {
  @PropSync("value", { type: Boolean, required: true })
  public syncedValue!: boolean;

  @PropSync("selectedUser", { type: Object, default: null })
  public syncedSelectedUser!: UserPromotionListEntry | null;

  public messageHeaders = [
    { text: "Event", value: "event", sortable: false },
    { text: "Messaged By", value: "messagedBy", sortable: false },
    { text: "Date", value: "timestamp", sortable: false },
    { text: "Comment", value: "comment", sortable: false },
  ];

  public formatTimestamp(timestamp: string): string {
    if (!timestamp) {
      return "N/A";
    }
    try {
      // Parse ISO 8601 timestamp and format using browser locale
      const date = new Date(timestamp);
      return date.toLocaleString();
    } catch (error) {
      return "Invalid date";
    }
  }

  public get sortedMessages(): UserPromotionMessage[] {
    if (!this.syncedSelectedUser) {
      return [];
    }
    return [...this.syncedSelectedUser.promotionMessages].sort((a, b) => {
      if (!a.timestamp) {
        return 1;
      }
      if (!b.timestamp) {
        return -1;
      }
      try {
        // Parse ISO 8601 timestamps directly
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB.getTime() - dateA.getTime(); // Most recent first
      } catch (error) {
        return 0;
      }
    });
  }
}
